export default __webpack_public_path__ + "static/Plots0027-015aeac6dc63dd332e0e094a84fe33db.jpg";